import { Controller } from "@hotwired/stimulus"

// Inline text editing for a block in the builder preview. Makes the element
// contenteditable and, on blur, PATCHes the block's prop (text / label).
export default class extends Controller {
  static values = {
    url: String,
    nodeId: String,
    field: { type: String, default: "text" }
  }

  connect() {
    this.element.setAttribute("contenteditable", "plaintext-only")
    this.element.classList.add("outline-none", "cursor-text")
    this.original = this.element.innerText
  }

  disconnect() {
    this.element.removeAttribute("contenteditable")
  }

  async save() {
    const value = this.element.innerText.trim()
    if (value === this.original) return

    window.dispatchEvent(new CustomEvent("builder:save-started"))
    const previous = window.__builderSaveQueue || Promise.resolve()
    const operation = previous.catch(() => {}).then(() => this.performSave(value))
    window.__builderSaveQueue = operation.catch(() => {})
    return operation
  }

  async performSave(value) {
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          node_id: this.nodeIdValue,
          inline: true,
          props: { [this.fieldValue]: value }
        })
      })
      if (!response.ok) throw new Error(`${response.status}`)
      this.original = value
      this.flash("green")
      window.dispatchEvent(new CustomEvent("builder:frame-refresh"))
      window.dispatchEvent(new CustomEvent("builder:save-finished", { detail: { ok: true } }))
    } catch (e) {
      this.element.innerText = this.original
      this.flash("red")
      window.dispatchEvent(new CustomEvent("builder:save-finished", { detail: { ok: false } }))
      throw e
    }
  }

  flash(color) {
    const cls = color === "green" ? ["ring-2", "ring-green-400"] : ["ring-2", "ring-red-400"]
    this.element.classList.add(...cls)
    setTimeout(() => this.element.classList.remove(...cls), 600)
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
